<template>
  <div
    class="md:bg-grey-background-subdued flex flex-row grow max-w-[1920px] mx-auto xl:border-x-1 border-grey-divider-subdued border-solid"
  >
    <div
      :class="[
        `${hasSelectedItemStyles} flex flex-col justify-between md:sticky md:overflow-y-auto h-[calc(100dvh-var(--nav-height,0px))] top-[3rem] md-1:top-[5rem] w-full md:w-[60%] md:max-w-[452px] md:min-w-[262px] border-r-1 border-grey-divider-subdued border-solid bg-grey-background-subdued md:bg-white`,
      ]"
    >
      <div class="h-full flex flex-col justify-between">
        <nav>
          <slot name="listItems" />
        </nav>
      </div>
    </div>
    <section
      ref="selectedListItemSection"
      :class="`${selectedItemId ? '' : 'hidden md:flex'} flex flex-col items-start w-full relative primary-focus`"
    >
      <Button
        variant="back"
        class="md:hidden ml-[-8px] text-left leading-4 pt-24 pl-16"
        :value="backButtonText"
        @click="
          () => {
            $emit('backButtonClick');
          }
        "
      />
      <slot name="selectedListItem" />
    </section>
  </div>
</template>

<script lang="ts">
import Button from '../button/Button.vue';

export default {
  name: 'ListSelectionLayout',
  components: {
    Button,
  },
  props: {
    backButtonText: {
      required: true,
      type: String,
    },
    selectedItemId: {
      required: true,
      validator(value) {
        return typeof value === 'string' || value === null;
      },
    },
  },
  computed: {
    hasSelectedItemStyles(): string {
      return this.selectedItemId ? 'hidden md:flex' : '';
    },
  },
  watch: {
    selectedItemId(val, prev) {
      if (val == null || prev == null) return;
      this.setContentSectionTabbing();
    },
  },
  methods: {
    setContentSectionTabbing(): void {
      // save reference to selected list element before changing focus to content section.
      const selectedListItem = document.activeElement as HTMLElement;
      const selectedListItemSectionRef = this.$refs.selectedListItemSection as HTMLElement;

      selectedListItemSectionRef?.focus();
      // scroll to top needed because focus will change the window scroll.
      window.scrollTo(0, 0);

      const keydownHandler = (): void => {
        const prevFocusedItem = document.activeElement as HTMLElement;

        setTimeout(() => {
          const curFocusedItem = document.activeElement as HTMLElement;
          // if the previous element is in content section, and the cur element is not, reset focus back to selected list item.
          if (selectedListItemSectionRef?.contains(prevFocusedItem) && !selectedListItemSectionRef?.contains(curFocusedItem)) {
            selectedListItem?.focus();
          }
        }, 0);
      };

      document.removeEventListener('keydown', keydownHandler);
      document.addEventListener('keydown', keydownHandler);
    },
  },
};
</script>
